<template>
    <tr class="party-cost-row">
        <td>
            <div class="field-label is-normal">
                <label class="label">
                    {{ cost.title || 'Number in party' }}
                    <p
                        v-if="cost.n_max"
                        class="help is-info"
                        v-text="costSpotsAvailable + ' of ' + cost.n_max + ' spots available'"
                    />
                    <p
                        v-else-if="cost.n_max"
                        class="help is-info"
                        v-text="cost.n_max + ' spots available'"
                    />
                </label>
            </div>
        </td>
        <td>
            <label-input
                type="number"
                :input-class="['numberInput']"
                v-model="$v.n_people.$model"
            />
        </td>
        <td>
            <span style="font-size: 80%; margin-left: 5px;">x ${{ cost.cost }}</span>
        </td>
        <td style="padding-left: 15px; padding-top: 5px;">
            <p
                v-if="$v.n_people.$dirty && $v.n_people.$invalid && n_people > 0"
                class="help is-danger"
                v-text="`Choose a number no greater than ${cost.n_max}.`"
            />
            <p
                v-else-if="$v.n_people.$dirty && $v.n_people.$invalid"
                class="help is-danger"
                v-text="'Enter a valid count.'"
            />
            <p
                v-else-if="costIsWaitlist && !partySizeError"
                class="help is-info"
                v-html="'Not enough spots available in this category.<br>You will be placed on the wait list.'"
            />
        </td>
    </tr>
</template>

<script>
import LabelInput from '../../_components/form/LabelInput.vue';
import { validationMixin } from 'vuelidate';
import { minValue, integer } from 'vuelidate/lib/validators';

const notTooMany = function(n_people) {
    return this.cost.n_max === null ? true : (n_people <= this.cost.n_max);
};

export default {
    components: {
        LabelInput,
    },
    mixins: [ validationMixin ],
    props: {
        cost: {
            type: Object,
        },
        spots_available: {
            type: Number,
        },
        partySizeError: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            n_people: null,

        };
    },
    computed: {
        costSpotsAvailable() {
            return Math.max(
                ((this.cost.n_max ?? 0) - (this.cost.n_reserved ?? 0)),
                0
            );
        },

        costIsWaitlist() {
            return this.cost.n_max && (Number(this.n_people) > this.costSpotsAvailable);
        },
    },
    validations() {
        return {
            n_people: {
                integer,
                minValue: minValue(0),
                notTooMany,
            },
        };
    },
    watch: {
        n_people(cur) {
            this.$emit('input', cur)
        },
    },
}
</script>

<style lang="scss">
.party-cost-row {
    td {
        vertical-align: top;
    }
    .help {
        font-size: 10pt;
        margin-top: -2px !important;

        &.is-info {
            color: #1a6e74;
        }

        &.is-danger {
            color: #d8842e;
        }
    }
}
</style>
